import React from "react";
import { Link } from "react-router-dom";
import usePageMeta from "../../utils/usePageMeta";
import "./NotFound.css";

const NotFound = () => {
  usePageMeta({
    title: "Page Not Found | Shamshersons",
    noindex: true,
  });

  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
